import { RefObject, useEffect, useRef } from 'react';

export default function useMutationObserver<T extends HTMLElement | Element | void = void>(
    element: RefObject<T>,
    callback: MutationCallback,
    options: MutationObserverInit = {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true
    }
) {
    // Create a ref that stores handler
    const savedCallback = useRef(callback);
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        const targetElement = element?.current;
        if (!targetElement) return;

        const observer = new MutationObserver(savedCallback.current);
        observer.observe(targetElement, options);
        return () => observer.disconnect();
    }, [element, options]);
}
